import { styled } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
export const DescriptionList = styled('dl', shouldNotForwardProps('termWidth'))(({ theme, termWidth }) => ({
    display: 'grid',
    gridTemplateColumns: 'min(50%, 20rem) auto',
    fontSize: theme.typography.body1.fontSize,
    lineHeight: '1.5rem',
    margin: 0,
    ...(termWidth && {
        gridTemplateColumns: `${termWidth} auto`,
    }),
}));
const getBaseStyles = (theme) => ({
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    // borderColor: alpha(theme.palette.text.primary, 0.05),
    borderColor: `color-mix(in oklab, ${theme.vars.palette.text.primary} 5%, transparent)`,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    margin: 0,
    // @ts-expect-error What type to choose to allow ':first-of-type'?
    ':first-of-type': {
        borderStyle: 'none',
    },
});
export const DescriptionTerm = styled('dt')(({ theme }) => ({
    ...getBaseStyles(theme),
    gridColumnStart: 1,
    color: theme.palette.text.muted,
}));
export const DescriptionDetailsStyled = styled('dd')(({ theme }) => ({
    ...getBaseStyles(theme),
    color: theme.palette.text.primary,
}));
